import Box from "@material-ui/core/Box";
import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import Carousel from "react-material-ui-carousel";

import {useTranslation} from "react-i18next";
import GenericLogoLabel from "./miscelaneous/genericLogoLabel";
import ReviewNumberLabel from "./miscelaneous/reviewNumberLabel";
import ProviderMeter from "./miscelaneous/providerMeter";
import ReviewCard from "./card/ReviewCard";
import {useMiscellaneousStyles} from "../styles/miscellaneous";
import useTheme from "@material-ui/core/styles/useTheme";

export function useWindowSize(element) {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            if (element && element.current) {
                setSize([element.current.getBoundingClientRect().width, element.current.getBoundingClientRect().height])
            } else {
                setSize([window.innerWidth, window.innerHeight]);
            }
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, [element, setSize]);
    return size;
}

export default function CarouselWidget(props) {

    const {relativeResponsive, seat_id, apiUrl, footer, logo,stats,profilePic} = props;

    const classes = useMiscellaneousStyles();
    const {t} = useTranslation()
    const smallTrigger = 800;

    let widgetRef = useRef();
    const [width] = useWindowSize(relativeResponsive ? widgetRef : null);
    const [reviews, setReviews] = useState([])
    const [totalReviews, setTotalReviews] = useState(0)
    const [avgBySource, setAvgBySource] = useState([])
    const [n] = useState(15)
    const [currentPage, setCurrentPage] = useState(0)
    const theme = useTheme();

    useEffect(() => {
            if (seat_id)
                fetch(`${apiUrl}/seats/${seat_id}/reviews/widgets`, {
                    method: "GET",
                }).then(async (body) => {
                    if (body.ok) {
                        let data = await body.json()
                        setReviews(data.reviews)
                        setTotalReviews(data.count)
                        setAvgBySource(data.avg)
                    }
                    // setFetched(true)
                }).catch(err => console.error(err))
        }, [apiUrl, n, seat_id]
    );

    function getPage() {
        let pages = [];
        let refNumber = width > smallTrigger ? 3 : 1
        let maxPages = Math.ceil(reviews === undefined ? 0 : reviews.length / refNumber);
        let currentIndex = 0;
        for (let i = 0; i < maxPages; i++) {
            pages.push(reviews.slice(currentIndex, currentIndex + refNumber));
            currentIndex = currentIndex + refNumber;
        }
        return pages;
    }

    function calculateMargin(i) {

        if (width < smallTrigger) {
            return {r: 0, l: 0}
        }

        return {r: i < 2 ? "30px" : 0, l: 0}
    }

    return <div ref={widgetRef}>
        <Box display="flex"
             flexDirection="column"
             justifyContent="center"
             alignItems="center"
             width={"100%"}
             color={theme.color ? theme.color : 'black'}
             p={2}
        >

            {
                stats ? <React.Fragment>
                    <Box display="flex"
                         flexDirection="row"
                         justifyContent="center"
                         flexWrap="wrap"
                         alignItems="center"
                         width={"100%"}
                         pb={1}
                    >
                        {avgBySource !== undefined ?
                            avgBySource.map((data, i) =>
                                <div className={'ProviderMeter'}
                                     key={i}
                                     style={{
                                         marginRight: 27 / 2,
                                         marginLeft: 27 / 2,
                                         marginBottom: 20
                                     }}>
                                    <ProviderMeter
                                        provider={`${data._id}`}
                                        value={data.avg}
                                    />
                                </div>
                            ) : null
                        }
                    </Box>
                    <Box pb={2}>
                        <ReviewNumberLabel value={totalReviews}/>
                    </Box>
                </React.Fragment>: null
            }

            <Carousel
                autoPlay={false}
                className={classes.UMCarousel}
                navButtonsAlwaysVisible={true}
                key={getPage().length}
                startAt={currentPage}
                navButtonsProps={{
                    className: classes.carouselBtn
                }}
                next={() => {
                    if (currentPage === getPage().length - 1) {
                        setCurrentPage(0)
                    } else {
                        setCurrentPage(currentPage + 1)
                    }
                }}
                prev={() => {
                    if (currentPage === 0) {
                        setCurrentPage(getPage().length - 1)
                    } else {
                        setCurrentPage(currentPage - 1)
                    }
                }}
            >
                {
                    getPage().map((page, i) => {
                        return <Box
                            display="flex"
                            flexDirection="row"
                            justifyContent="center"
                            alignItems="center"
                            width={"100%"}
                            className={"cardBox"}
                            pr={width > smallTrigger ? '55px' : '45px'}
                            pl={width > smallTrigger ? '55px' : '45px'}
                            key={i}
                        >
                            {
                                page.map((review, i) =>
                                    <Box
                                        width={width > smallTrigger ? "33%" : "100%"}
                                        mr={calculateMargin(i).r}
                                        ml={calculateMargin(i).l}
                                        className={"card"}
                                        key={i}
                                    >
                                        <ReviewCard review={review} profilePic={profilePic}/>
                                    </Box>
                                )
                            }
                        </Box>
                    })
                }
            </Carousel>
            {footer ? <Box pt={3}>
                <GenericLogoLabel text={t("W_VERIFIED_F")}
                                  link={"https://www.climbo.com"}
                                  logo={logo}/>
            </Box> : null}

        </Box>
    </div>
}